<template>
    <div class="">
        <form method="POST" :action="targetUrl">
            <input type="hidden" name="_token" :value="csrf" />
            <input type="hidden" name="_return_redirect" value="false" />
            <install-wizard-card>
                <template #top-header>
                    Shipping
                </template>
                <template #top-content>

                </template>

                <template #body-summary>
                    <span v-if="hasComments">
                        Here's the Sonicu shipping information:
                    </span>
                    <span v-else>
                        Once shipped, your order information will be placed here.
                    </span>
                </template>

                <template #body-action>
                    <div v-if="permissions.isSonicu()" class="flex flex-wrap">
                        <div class="w-full">
                            <textarea name="comments"
                                      class="border-2 flex w-full p-2"
                                      rows="10"
                                      placeholder="Enter the status for the customer to view:"
                                      v-model="model.comments"
                            ></textarea>
                        </div>
                    </div>
                    <div v-else-if="hasComments" class="pl-8">
                        <div class="bg-gray-50 overflow-hidden rounded-lg">
                            <div class="px-4 py-5 sm:p-6">
                                <span style="white-space: pre;">{{model.comments}}</span>
                            </div>
                        </div>
                    </div>
                </template>

                <template #bottom-header>
                    <span v-if="!permissions.isSonicu() && hasComments">Sonicu has processed your order. </span>
                    <span v-else>Sonicu will complete this step for you! </span>
                </template>
                <template #bottom-button v-if="permissions.isSonicu()">
                    <a>
                        <button type="submit"
                                class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700 active:bg-blue-700">
                            <slot name="bottom-button-text">Save Shipping Info</slot>
                        </button>
                    </a>
                </template>
                <template #bottom-button v-else>
                    <span>&nbsp;</span>
                </template>
            </install-wizard-card>
        </form>
    </div>
</template>

<script>
    import InstallWizardCard from "./InstallWizardCard";
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

    export default {
        name: "InstallWizardShipping",
        mixins: [SonicuCoreMixin],
        props: {
            model: Object,
        },
        components: {InstallWizardCard},
        methods: {
        },
        computed: {
            targetUrl(){
                return window.location.pathname;
            },
            hasComments() {
                return this.model.comments.length !== 0
            }
        }
    }
</script>

<style scoped>

</style>